import { TeamTranslations } from "./team-pt-br";

export const TEAM_FR_FR: TeamTranslations = {
	custom: "Personnalisé",
	showTableByBar: "Afficher le tableau par bar",
	noEmployees: "Aucun collaborateur trouvé",
	notifications: {
		removeEmployee: "Collaborateur supprimé avec succès",
		removeMultipleEmployees: "Collaborateurs supprimés avec succès",
		addEmployee: "Collaborateur ajouté avec succès",
		addZigTagToWaiter: "ZigTag ajouté avec succès",
		addMultipleEmployees: {
			error: "Erreur lors de l'ajout des collaborateurs:",
			success: "Collaborateurs ajoutés avec succès:",
		},
		editEmployee: "Collaborateur modifié avec succès",
		editMultipleEmployees: "Collaborateurs modifiés avec succès",
		changePlace_one: "Collaborateur transféré avec succès",
		changePlace_other: "Collaborateurs transférés avec succès",
		changePlaceError: "Les collaborateurs n'ont pas été transférés",
	},
	header: {
		titleOrg: "Équipe",
		titlePlace: "Opérateurs de PDV",
		descriptionOrg:
			"Ajouter, modifier et supprimer des collaborateurs de l'organisation (utilisateurs du panneau de contrôle).",
		descriptionPlace:
			"Ajouter, modifier et supprimer des opérateurs de PDV à {{ placeName }}",
		alert: {
			link: "accédez à la section équipe de l'organisation.",
			text: "Pour ajouter des collaborateurs du panneau de contrôle ou gérer les rôles,",
		},
		searchPlaceholder: "Rechercher",
		searchEmployee: "Rechercher un collaborateur",
		filterByPlace: "Filtrer par lieu",
		closeSearch: "Fermer",
		cleanSearch: "Nettoyer",
		closeFilter: "Fermer le filtre",
		cleanFilter: "Nettoyer le filtre",
	},
	headerActions: {
		addEmployee: "Ajouter un collaborateur",
		importEmployees: "Importer des collaborateurs",
		selectAllEmployee: "Sélectionner tous les collaborateurs ({{ count }})",
		editSelectedCollaborator_one: "Modifier le collaborateur sélectionné ({{count}})",
		editSelectedCollaborator_other:
			"Modifier les collaborateurs sélectionnés ({{count}})",
		deleteSelectedCollaborator_one: "Supprimer le collaborateur sélectionné ({{count}})",
		deleteSelectedCollaborator_other:
			"Supprimer les collaborateurs sélectionnés ({{count}})",
		uncheckEmployee_one: "Désélectionner le collaborateur sélectionné ({{count}})",
		uncheckEmployee_other: "Désélectionner les collaborateurs sélectionnés ({{count}})",
		changePlaceSelectedCollaborator_one:
			"Changer le lieu du collaborateur sélectionné ({{count}})",
		changePlaceSelectedCollaborator_other:
			"Changer le lieu des collaborateurs sélectionnés ({{count}})",
		buttonBulkActions: {
			titleBtn: "Actions en masse",
			titleModal: "Actions en masse ({{ count }} sélectionnés)",
			titleModalMode: "Mode de sélection",
			removeSelected: "Supprimer la sélection des opérateurs ({{count}})",
			selectAllByRole: "Sélectionner tous les opérateurs par rôle",
			selectRole: "Sélectionner tous les {{name}}",
			titleRole: "Personnalisé",
			editSelectedCollaborator_one: "Modifier le collaborateur sélectionné",
			editSelectedCollaborator_other: "Modifier les collaborateurs sélectionnés",
			deleteSelectedCollaborator_one: "Supprimer le collaborateur sélectionné",
			deleteSelectedCollaborator_other: "Supprimer les collaborateurs sélectionnés",
			changePlaceSelectedCollaborator_one: "Changer le lieu du collaborateur sélectionné",
			changePlaceSelectedCollaborator_other:
				"Changer le lieu des collaborateurs sélectionnés",
		},
	},
	columns: {
		name: "Collaborateur",
		username: "Nom d'utilisateur",
		role: "Rôle",
		cpf: "CPF",
		pub: {
			none: "Aucun bar",
			label: "Bars",
			mainBar: "Bar principal",
			bars: "Bars secondaires",
		},
		places: "Lieux",
		placesNone: "Aucun lieu sélectionné",
		deleteEmployee: "Supprimer le collaborateur",
		updateEmployee: "Modifier le collaborateur",
		duplicateEmployee: "Dupliquer le collaborateur",
		changePlace: "Changer le lieu",
	},
	form: {
		create: {
			title: "Nouvel Opérateur",
			descriptionOrg:
				"Créer un collaborateur de l'organisation (utilisateur du panneau de contrôle)",
			descriptionPlace: "Créer un opérateur à {{ placeName }}",
		},
		update: {
			title: "Modifier l'Opérateur",
			descriptionOrg:
				"Modifier un collaborateur de l'organisation (utilisateur du panneau de contrôle)",
			descriptionPlace: "Modifier un opérateur à {{ placeName }}",
		},
		multipleUpdate: {
			title: "Modifier les Opérateurs {{count}}",
			descriptionOrg:
				"Modifier les collaborateurs sélectionnés de l'organisation (utilisateur du panneau de contrôle)",
			descriptionPlace: "Modifier {{count}} opérateurs à {{ placeName }}",
			warning: {
				title: "Champs non remplis",
				description:
					"Les champs non remplis conservent les valeurs originales du collaborateur.",
			},
		},
		actions: {
			discardCreate: "Annuler la création",
			discardEdit: "Annuler les modifications",
			create: "Créer un collaborateur",
			save: "Enregistrer les modifications",
		},
		dataEmployees: {
			title: "Données du Collaborateur",
			name: {
				label: "Nom",
				placeholder: "Entrez le nom",
				required: "Le nom est obligatoire",
				min: "Le nom doit comporter au moins 3 caractères",
			},
			username: {
				label: "Nom d'utilisateur",
				placeholder: "Entrez le nom d'utilisateur",
				required: "Le nom d'utilisateur est obligatoire",
				lowercase: "Le nom d'utilisateur doit être en minuscules",
				noSpaces: "Le nom d'utilisateur ne peut pas contenir d'espaces",
				tooltip: "Le nom d'utilisateur doit être unique",
			},
			email: {
				label: "Email",
				placeholder: "Entrez l'email",
				required: "L'email est obligatoire",
				invalid: "L'email est invalide",
			},
			password: {
				label: "Mot de passe",
				placeholder: "Créez le mot de passe d'accès",
				required: "Le mot de passe est obligatoire",
				min: "Le mot de passe doit comporter au moins 6 caractères",
				notEmpty: "Le mot de passe ne peut pas être vide",
			},
			cpf: {
				label: "CPF",
				placeholder: "Saisissez le CPF",
				invalid: "CPF invalide. Vérifiez les chiffres.",
			},
		},
		renameDataEmployees: {
			title: "Nom",
			name: {
				label: "Renommer",
				placeholder: "Renommer les collaborateurs en masse",
			},
			initialNameNumber: {
				label: "Numéroter à partir de",
				placeholder: "Entrez la valeur initiale",
				nonnegative: "La valeur doit être supérieure à 0",
			},
			renameInitialNameNumber: {
				validation: "Les champs doivent être remplis ensemble",
				required: "Ce champ est obligatoire",
			},
			info:
				"En renommant en masse, tous les collaborateurs sélectionnés auront le même nom. Pour les différencier, nous les numérons automatiquement à partir du numéro que vous entrez dans la boîte de texte ci-dessus",
		},
		placeSection: {
			title: "Lieux",
			selectedPlaces: {
				required: "Vous devez sélectionner au moins un lieu",
				selectAll: "Sélectionner tout",
				none: "Aucun lieu sélectionné",
				min: "Vous devez sélectionner au moins un lieu",
			},
		},
		extraInfoSection: {
			title: "Informations supplémentaires",
			pub: {
				label: "Bars",
				labelMainBar: "Bar principal / point de vente",
				placeholder: "Sélectionnez un bar de {{ placeName }}",
				required: "Vous devez sélectionner au moins un bar principal",
				notApplicableForRole: "Ne s'applique pas à ce poste",
			},
			fichasAmount: {
				label: "Quantité de voies en fiche",
				placeholder: "Entrez la quantité",
				nonnegative: "La quantité doit être supérieure ou égale à 0",
			},
			menuVisualizationType: {
				label: "Visualisation du menu",
				placeholder: "Entrez la quantité",
				tooltip: {
					Grid: "Grande photo : 2 colonnes",
					SmallGrid: "Petite photo : 3 colonnes",
					NoPicture: "Sans photo : 3 colonnes",
				},
				type: {
					Grid: "Grande photo",
					SmallGrid: "Petite photo",
					NoPicture: "Sans photo",
				},
			},
			setupNaPonta: {
				allRoles: "Tous les rôles",
				rolesCanCreate: {
					label: "Rôles que cet utilisateur peut créer",
					tooltip:
						"Seuls les rôles et bars sélectionnés seront disponibles pour cet opérateur lors de l'ajout de nouveaux opérateurs de PDV pendant l'opération.",
				},
				barsForCreation: {
					label: "Bars pour la création d'opérateurs",
					tooltip:
						"Bars où cet utilisateur peut donner accès à la création d'opérateurs.",
					placeholder: "Sélectionnez les bars",
				},
			},
		},
		rolesAndPermissions: {
			titleOrg: "Rôles et Permissions du Tableau de Bord",
			titlePlace: "Rôles et Permissions du PDV",
			employeeRole: {
				label: "Rôle",
				placeholder: "Sélectionnez un rôle",
				none: "Aucun rôle",
				custom: "Personnalisé",
				required: "Le rôle est obligatoire",
				selectAtLeastOnePermission:
					"Vous devez sélectionner au moins une permission de PDV supplémentaire",
				selectAtLeastOneRole:
					"Sélectionnez au moins un rôle pour le Setup au Point de Vente",
				selectAtLeastOneBar:
					"Sélectionnez au moins un bar pour le Setup au Point de Vente",
			},
			zigTag: {
				label: "ZigTag",
				placeholder: "Entrez le numéro du ZigTag",
				nonnegative: "La valeur doit être supérieure ou égale à 0",
			},
			permissions: {
				operationalPermissions: "Permissions du PDV",
				managerialPermissions: "Permissions managériales du PDV",
				permissionsOrg: "Accès au tableau de bord",
				paymentMethodPermissions: "Méthodes de paiement",
			},
			type: {
				label: "Type de collaborateur",
				placeholder: "Aucun",
				invalid: "Type de collaborateur invalide",
			},
		},
		moreThanOneEmployee: {
			title: "Ajouter plus d'un collaborateur",
			initialValue: "Entrez la valeur initiale",
			finalValue: "Entrez la valeur finale",
			validationUntil: "La valeur finale doit être supérieure à la valeur initiale",
			negativeValue: "Les valeurs doivent être supérieures à 0",
			required: "Les champs sont obligatoires",
			nonnegative: "La valeur doit être supérieure ou égale à 0",
			since: {
				label: "Depuis",
			},
			until: {
				label: "Jusqu'à",
			},
			cpfAlert: {
				title: "Important",
				message:
					"Le CPF est attribué uniquement au premier opérateur créé ; ce champ ne sera pas rempli pour les autres.",
			},
		},
		changePlace: {
			title: "Changer le lieu des collaborateurs",
			description:
				"Sélectionnez un nouveau lieu pour les collaborateurs sélectionnés : {{ employeeNames }}",
			place: {
				label: "Lieu",
				placeholder: "Sélectionnez un lieu",
				required: "Le lieu est obligatoire",
			},
			mainBar: {
				label: "Bar principal",
				placeholder: "Sélectionnez un bar",
			},
			barIds: {
				label: "Bars",
				placeholder: "Sélectionnez un ou plusieurs bars",
			},
		},
		changePlaceEmployee: {
			place: {
				required: "Le lieu est obligatoire",
			},
		},
		sectors: {
			title: "Secteurs",
			switchTitle: "Limiter la visualisation par secteurs",
			switchDescription:
				"Choisissez quels secteurs des lieux seront disponibles pour ce collaborateur.",
			selectSectors: "Sélectionner les secteurs",
			noSectorsFound: "Aucun secteur trouvé",
			requiredSectors: "Vous devez sélectionner au moins un secteur",
		},
		vendors: {
			title: "Vendors",
			switchTitle: "Limiter la visualisation par vendors",
			switchDescription:
				"Choisissez quels vendors des lieux seront disponibles pour ce collaborateur.",
			selectVendors: "Sélectionner les vendors",
			noVendorsFound: "Aucun vendor trouvé",
			requiredVendors: "Vous devez sélectionner au moins un vendor",
			selectTitle: "Vendors avec accès",
			deleteSelectedVendors: "Voulez-vous vraiment désactiver la limitation par vendors?",
			deleteSelectedVendorsSubtitle:
				"En désactivant cette fonctionnalité, ce collaborateur passera à visualiser les informations de tous les vendors des lieux.",
			delete: "Désactiver même ainsi",
		},
	},
	deleteEmployeeModal: {
		title: "Voulez-vous supprimer le collaborateur?",
		description:
			"En supprimant le collaborateur, son utilisateur sera invalidé. Cette action ne peut pas être annulée.",
		buttonCancel: "Fermer",
		buttonConfirm_one: "Supprimer le collaborateur ({{ count }})",
		buttonConfirm_other: "Supprimer les collaborateurs ({{ count }})",
	},
	reportPrint: {
		title: "Importer des collaborateurs",
		btnDownloadTemplate: "Télécharger le modèle",
		spreadsheet: "Importer une feuille de calcul",
		sheetFileName: "Collaborateurs",
		sheetColumns: {
			name: {
				label: "Nom du Collaborateur",
				sample: "William",
			},
			username: {
				label: "Nom d'utilisateur",
				sample: "willzig",
			},
			password: {
				label: "Mot de passe",
				sample: "123456",
			},
			zigTag: {
				label: "ZigTag (optionnel)",
				sample: "123Z7JH",
			},
			cpf: {
				label: "CPF (optionnel)",
				sample: "529.982.247-25",
			},
			fichasAmount: {
				label: "Quantité de voies en fiche",
				sample: "2",
			},
			multiple: {
				label: "Quantité à ajouter en lot",
				sample: "1",
			},
		},
		role: {
			label: "Rôle",
			placeholder: "Sélectionnez un rôle",
			none: "Aucun rôle",
			custom: "Personnalisé",
		},
		pub: {
			label: "Bars",
			labelMain: "Bar principal",
			placeholder: "Sélectionnez un bar",
			none: "Aucun bar",
		},
		permissions: {
			label: "Permissions",
		},
		info:
			"Tous les employés seront ajoutés à {{ placeName }} avec le rôle et le bar sélectionnés ci-dessus",
		discard: "Annuler l'importation",
		finalize: "Finaliser l'importation",
	},
	validateTeamReport: {
		emptySheet: "Aucune donnée trouvée dans la feuille",
		existingEmployees: "Employés existants : {{ usernames }}",
		duplicateUsernames: "Logins en double trouvés : {{ usernames }}",
		invalidSheet: "Données invalides trouvées : {{ errors }}",
		invalidRow: "Ligne {{ index }} : {{ errors }}",
		invalid: {
			name: "Nom invalide",
			username: "Login invalide",
			usernameChars: "Le login contient des caractères invalides",
			password: "Mot de passe invalide",
			multiple: "Valeur multiple invalide",
			multipleGreaterThan: "Multiple supérieur à la limite autorisée",
			cpf: "CPF invalide",
		},
	},
	duplicate: {
		title: "Dupliquer le collaborateur",
		success: "Collaborateur dupliqué avec succès",
		error: "Erreur lors de la duplication du collaborateur",
		form: {
			description:
				"Lors de la duplication d'un collaborateur, toutes ses permissions sont importées.",
			name: {
				label: "Nom",
				placeholder: "Entrez le nom",
				required: "Le nom est obligatoire",
				min: "Le nom doit comporter au moins 3 caractères",
			},
			username: {
				label: "Nom d'utilisateur",
				placeholder: "Entrez le nom d'utilisateur",
				required: "Le nom d'utilisateur est obligatoire",
				lowercase: "Le nom d'utilisateur doit être en minuscules",
				noSpaces: "Le nom d'utilisateur ne peut pas contenir d'espaces",
			},
			password: {
				label: "Mot de passe",
				placeholder: "Créez le mot de passe d'accès",
				required: "Le mot de passe est obligatoire",
				notEmpty: "Le mot de passe ne peut pas être vide",
			},
			submit: "Créer une copie de collaborateur",
			close: "Fermer",
		},
	},
};
